import { createStore } from 'vuex';
import { eventCalendar } from './modules/event-calendar';

export default createStore({
  modules: { eventCalendar },
});
